import { AbstractControl, ValidatorFn } from '@angular/forms';

// Cannot contain the login or name
export function tripleSequentialCharactersValidator(): ValidatorFn {
	return (control: AbstractControl) => {
		const passwordString: string = control.value;
		if (!passwordString) return null;
		let containsTriples: boolean = false;

		for (let i = 0; i < passwordString.length - 2; i++) {
			if (passwordString[i] === passwordString[i + 1] && passwordString[i] === passwordString[i + 2]) {
				containsTriples = true;
				break;
			}
		}

		return containsTriples ? { tripleSequentialCharacters: true } : null;
	};
}
